import { useEffect, useRef, useState } from "react";
import { setFullRatePopover } from "redux-share/slices/popoversSlice";
import { useAppDispatch, useAppSelector } from "redux-share/hooks";
import { ConditionName, zIndex } from "interfaces";
import { conditions } from "helpers";
import CloseIcon from "../../icon-components/closeIcon";
import { shallowEqual } from 'react-redux'

const FullRate = () => {

    useAppSelector(({ popovers: { fullRatePopover } }) => ({ fullRatePopover }), shallowEqual);
    useAppSelector(({ videoData: { isComplexPortrait } }) => ({ isComplexPortrait }), shallowEqual);
    
    const [width, setWidth] = useState<number>(0);

    const dispatch = useAppDispatch();

    const intervalRef = useRef<any>(null)

    useEffect(() => {
        intervalRef.current = setInterval(() => setWidth((prev) => prev + 0.2), 10)

        return () => clearInterval(intervalRef.current);
    }, [])

    const handleClose = (timeout:any) => {
        dispatch(setFullRatePopover(false))
        clearInterval(intervalRef.current);
        timeout = setTimeout(() => dispatch(setFullRatePopover(undefined)), 500)
    }

    let timeout: any;

    useEffect(() => {
        if (width >= 100) handleClose(timeout)

        return () => clearTimeout(timeout);
    }, [width])

    const fullRateStyles = () => {
        let styles = "";

        if (conditions(ConditionName.isComplexPortrait)) styles = `!pl-absolute pl-mt-12 ${conditions(ConditionName.showFullRatePopover) ? "animate__backInRight" : "animate__backOutRight"}`;
        else if (conditions(ConditionName.isFullMobilePortrait)) styles = `!pl-absolute pl-top-12 pl-self-center pl-justify-center ${conditions(ConditionName.showFullRatePopover) ? "animate__backInRight" : "animate__backOutRight"}`;
        else styles = `!pl-absolute pl-top-3 pl-left-3 ${conditions(ConditionName.showFullRatePopover) ? "animate__backInDown" : "animate__backOutUp"}`;

        return styles;
    }

    return (
        <div className={`pl-relative pl-flex pl-items-center pl-border pl-border-secondary-300 pl-bg-secondary-100/[0.8] dark:pl-bg-gray-800/[0.8] pl-rounded-[4px] animate__animated ${fullRateStyles()}`} style={{ zIndex: zIndex.fullrate }}>
            <div className="pl-relative pl-bg-secondary-100 dark:pl-bg-gray-800 pl-p-2 pl-overflow-hidden pl-rounded-r-[4px]">
                <p className="pl-text-black dark:pl-text-white pl-text-[11px] pl-font-medium">ترافیک اینترنت شما تمام بها محاسبه می‌شود.</p>
                <div className="pl-absolute pl-bottom-0 pl-right-0 pl-w-full pl-h-[2px] pl-bg-dark-8">
                    <div className="pl-absolute pl-bottom-0 pl-right-0 pl-h-[2px] pl-bg-main-700" style={{ width: `${width}%` }}></div>
                </div>
            </div>
            <div className="pl-bg-secondary-700/[0.8] dark:pl-bg-gray-600/[0.8] pl-p-[10px] pl-cursor-pointer pl-rounded-l-[4px]" onClick={() => handleClose(timeout)}>
                <CloseIcon className="pl-stroke-secondary-50 pl-w-3 pl-h-3" />
            </div>
        </div>
    )
}

export default FullRate;